import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormView } from '@form/cer-form-view';

export class WarehouseForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {
    const view = new CerFormView();
    view.viewMetadata = {
      name: 'lagersteder', dataApiName: 'Warehouse', text: 'Lagersteder', textSingular: 'Lagersted',
      primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
    };
    view.fieldMetadata = [];
    viewSet.viewAdd(view);

  }
}
